interface LiveRegionProps {
  message: string
}

export function LiveRegion({ message }: LiveRegionProps) {
  return (
    <div role="status" aria-live="polite" aria-atomic="true" className="lookup-field__live-region">
      {message}
    </div>
  )
}
